import { isTenantOwnerAdmin } from "utils/isTenantOwnerAdmin"
import React, { useEffect, useState } from "react"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import Paginations from "components/Common/Paginations"
import Switch from "components/Shared/Switch"
import DeleteModal from "components/Common/DeleteModal"
import { showAlert } from "store/reducers/alertReducer"
import TableShimmer from "components/Shared/TableShimmer"
import DownloadCSV from "components/Shared/DownloadCSV"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import placeholderImage from "assets/images/placeholderImage.png"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import {
  deleteItem,
  getItemsList,
  updateItemStatus,
} from "store/actions/itemsAction"
import ItemFilter from "../Items/ItemFilter"
import { getCategories } from "store/actions/categoriesAction"
import { pdfDownload } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import { useTranslation } from "react-i18next"
import { getCurrencyLabelByCountryCode } from "utils/currency"
import { getBranchCountryList } from "store/actions/commonAction"
import useCrossModuleFilterPermissions from "hooks/useCrossModuleFilterPermissions"

const Combos = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Combos List ")

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const { comboId } = useParams()
  const searchParams = new URLSearchParams(location.search)
  const categoryParam = searchParams.get("category")
  const disabledBranchParam = searchParams.get("disabledBranch")
  const outOfStockBranchParam = searchParams.get("outOfStockBranch")
  const countryCodeParam = searchParams.get("countryCode")

  const minPrice = searchParams.get("minPrice")
  const maxPrice = searchParams.get("maxPrice")

  const pageNumber = parseInt(searchParams.get("page")) || 1
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [selectedId, setSelectedId] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [itemIdToDelete, setItemIdToDelete] = useState(null)

  const { allCategories } = useSelector(state => state.Categories)
  const { branchsList, countryList } = useSelector(state => state.Common)

  const initialPriceRange = (() => {
    if (minPrice !== null && maxPrice !== null) {
      return [Number(minPrice), Number(maxPrice)]
    }
    return [0, 1000] // Default values
  })()
  const [selectedFilters, setSelectedFilters] = useState({
    status: parseInt(searchParams.get("status") || "2"),
    sortOrder: parseInt(searchParams.get("sortOrder") || "1"),
    category: categoryParam
      ? categoryParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
    disabledBranch: disabledBranchParam
      ? disabledBranchParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
    outOfStockBranch: outOfStockBranchParam
      ? outOfStockBranchParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
    countryCode: countryCodeParam
      ? countryCodeParam.split(",").map(item => {
          const [label, value] = item.split(":")
          return { label, value }
        })
      : [],
  })

  const [priceRange, setPriceRange] = useState(initialPriceRange)
  const [isApiCalled, setIsApiCalled] = useState(false)

  // useEffect(() => {
  //   if (isApiCalled) {
  //     if (searchTerm) {
  //       const delayDebounceFn = setTimeout(() => {
  //         handleSearch()
  //       }, 500)

  //       return () => clearTimeout(delayDebounceFn)
  //     } else {
  //       handleSearch()
  //     }
  //   }
  // }, [searchTerm, selectedFilters, priceRange])

  const {
    loading,
    error,
    isLoading,
    isUpdating,
    message,
    actionType,
    totalCount,
    itemsPerPage,
    currentPage,
    totalPages,
    itemsLists,
  } = useSelector(state => state.Items)

  const { userRole, accountType } = useSelector(state => state.Login)
  const { canFilterByBranch } = useCrossModuleFilterPermissions()

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = getSubPermissions(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionView = isPermissionEnabled(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      4,
      "menus_2",
      accountType
    )
    const isPermissionEdit = getSubPermissions(
      userRole,
      4,
      "menus_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      4,
      "menus_4",
      accountType
    )
    if (
      !isPermissionList?.combo_access_view?.isEnabled ||
      !isPermissionView
    ) {
      navigate("/dashboard")
    } else {
      getAllCombos()
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  useEffect(() => {
    fetchBranchCountryList()
  }, [])

  useEffect(() => {
    // getAllCombos()
    getCategoriesList()
  }, [mode])

  const fetchBranchCountryList = () => {
    if (!canFilterByBranch) return
    dispatch(getBranchCountryList())
  }

  const getAllCombos = () => {
    const {
      status,
      sortOrder,
      category,
      disabledBranch,
      outOfStockBranch,
      countryCode,
    } = selectedFilters
    const disabledBranchIds = disabledBranch?.map(item => item.value)
    const outOfStockBranchIds = outOfStockBranch?.map(item => item.value)
    const updatedCountryCode = countryCode?.map(item => item.value) || []

    const categoryId =
      mode === "comboItems" ? [comboId] : category?.map(item => item.value)

    if (Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])) {
      if (priceRange[0] > priceRange[1]) {
        dispatch(
          showAlert({
            text: t("Minimum price cannot be greater than maximum price"),
            type: "error",
          })
        )
        return
      }
    }
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: status,
      orderBy: sortOrder,
      keyword: searchTerm,
      isCombo: true,
      category: categoryId,
      disabledBranch: disabledBranchIds || [],
      outOfStockBranch: outOfStockBranchIds || [],
      countryCode: updatedCountryCode,
      priceRange:
        Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])
          ? { min: priceRange[0], max: priceRange[1] }
          : {},
      // dateRange: {},
    }

    dispatch(getItemsList(payload))
    setIsApiCalled(true)
  }

  const getCategoriesList = () => {
    const isCombo = true
    dispatch(getCategories({ isCombo }))
  }

  const filters = [
    {
      name: "status",
      type: "select",
      options: [
        { label: t("All"), value: 2 },
        { label: t("Active"), value: 1 },
        { label: t("Deactive"), value: 0 },
      ],
      placeholder: t("All"),
    },
    {
      name: "disabledBranch",
      type: "multiSelect",
      options: branchsList?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      })),

      placeholder: t("Disable For Specific Branches"),
    },
    {
      name: "outOfStockBranch",
      type: "multiSelect",
      options: branchsList?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      })),

      placeholder: t("Select In-stock branches"),
    },
    {
      name: "countryCode",
      type: "multiSelect",
      options: countryList?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item.countryCode,
      })),

      placeholder: t("Select Countries"),
    },
  ]

  if (mode !== "comboItems") {
    filters.push({
      name: "category",
      type: "multiSelect",
      dependsOnCountry: true,
      options: [
        ...allCategories.map(item => ({
          label: language === "sa" ? item.nameAr : item.name,
          value: item._id,
        })),
      ],
      placeholder: t("Select Categories"),
    })
  }

  const handleFilterChange = (selectedValue, filterName) => {
    if (filterName === "countryCode") {
      const countryCodeList = selectedValue?.map(item => item.value) || []
      const isCombo = true
      dispatch(getCategories({ isCombo, countryCodeList }))
      setSelectedFilters(prevFilters => ({
        ...prevFilters,
        [filterName]: selectedValue,
        category: [],
      }))
      return
    }
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }

  const buildExportPayload = exportType => {
    const {
      status,
      category,
      disabledBranch,
      outOfStockBranch,
      countryCode,
    } = selectedFilters

    const categoryIds =
      mode === "comboItems" ? [comboId] : category?.map(item => item.value)

    const isDefaultPriceRange =
      priceRange[0] === 0 && priceRange[1] === 1000

    const payload = {
      status: Number(status),
      keyword: searchTerm || "",
      type: "ITEM",
      isCombo: true,
      exportType,
    }

    const countryCodes = countryCode?.map(item => item.value) || []
    if (countryCodes.length > 0) {
      payload.countryCode = countryCodes
    }

    const disabledBranchIds = disabledBranch?.map(item => item.value) || []
    if (disabledBranchIds.length > 0) {
      payload.disabledBranch = disabledBranchIds
    }

    const outOfStockBranchIds =
      outOfStockBranch?.map(item => item.value) || []
    if (outOfStockBranchIds.length > 0) {
      payload.outOfStockBranch = outOfStockBranchIds
    }

    if (
      !isDefaultPriceRange &&
      Number.isFinite(priceRange[0]) &&
      Number.isFinite(priceRange[1])
    ) {
      payload.priceRange = { min: priceRange[0], max: priceRange[1] }
    }

    if (categoryIds?.length > 0) {
      payload.category = categoryIds
    }

    return payload
  }

  const getApiCall = (page = 1) => {
    const {
      status,
      sortOrder,
      category,
      disabledBranch,
      outOfStockBranch,
      countryCode,
    } = selectedFilters

    const disabledBranchIds = disabledBranch?.map(item => item.value)
    const outOfStockBranchIds = outOfStockBranch?.map(item => item.value)
    const updatedCountryCode = countryCode?.map(item => item.value) || []

    const categoryIds =
      mode === "comboItems" ? [comboId] : category?.map(item => item.value)

    const searchParams = new URLSearchParams()
    searchTerm && searchParams.set("search", searchTerm)
    searchParams.set("status", status.toString())
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    if (category.length > 0) {
      const categoryString = category
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("category", categoryString)
    }
    if (disabledBranch.length > 0) {
      const disabledBranchString = disabledBranch
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("disabledBranch", disabledBranchString)
    }
    if (outOfStockBranch.length > 0) {
      const outOfStockBranchString = outOfStockBranch
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("outOfStockBranch", outOfStockBranchString)
    }
    if (Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])) {
      if (priceRange[0] > priceRange[1]) {
        dispatch(
          showAlert({
            text: t("Minimum price cannot be greater than maximum price"),
            type: "error",
          })
        )
        return
      }
      searchParams.set("minPrice", priceRange[0]?.toString())
      searchParams.set("maxPrice", priceRange[1]?.toString())
    }
    if (countryCode.length > 0) {
      const countryCodeString = countryCode
        .map(item => `${item.label}:${item.value}`)
        .join(",")
      searchParams.set("countryCode", countryCodeString)
    }

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      status: Number(status),
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      isCombo: true,
      disabledBranch: disabledBranchIds || [],
      outOfStockBranch: outOfStockBranchIds || [],
      category: categoryIds || [],
      countryCode: updatedCountryCode,
      priceRange:
        Number.isFinite(priceRange[0]) && Number.isFinite(priceRange[1])
          ? { min: priceRange[0], max: priceRange[1] }
          : {},
    }

    dispatch(getItemsList(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          if (mode === "comboItems") {
            navigate(
              `/menus/combos/${comboId}/items?${searchParams.toString()}`
            )
          } else {
            navigate(`/menus/combos?${searchParams.toString()}`)
          }
        }
      })
      .catch(error => {})
  }

  const handleSearch = () => {
    getApiCall(1)
  }

  const onPageChange = page => {
    getApiCall(page)
  }
  const handleReset = () => {
    const categoryId = mode === "comboItems" ? [comboId] : []

    setSearchTerm("")
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      status: 2,
      orderBy: 1,
      keyword: "",
      isCombo: true,
      category: categoryId,
      disabledBranch: [],
      outOfStockBranch: [],
      priceRange: {},
      dateRange: {},
    }

    dispatch(getItemsList(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          if (mode === "comboItems") {
            navigate(`/menus/combos/${comboId}/items?page=1`)
          } else {
            navigate(`/menus/combos?page=1`)
          }
        }
      })
      .catch(error => {})
    setPriceRange([0, 1000])
    getCategoriesList()

    setSelectedFilters({
      status: 2,
      sortOrder: 1,
      category: [],
      disabledBranch: [],
      outOfStockBranch: [],
      countryCode: [],
    })
  }

  const handleStatusClick = (id, status) => {
    const payload = {
      id,
      status: status === 1 ? "0" : "1", //deactive 1 active
    }
    dispatch(updateItemStatus(payload))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
    setSelectedId(id)
  }

  const handleDelete = () => {
    const payload = {
      id: itemIdToDelete,
      status: "2", // for delete
    }
    dispatch(deleteItem({ ...payload, setShowDeleteModal }))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const exportToCSV = async () => {
    const response = await pdfDownload(EXPORT_DATA, buildExportPayload("csv"))
    if (response) {
      const csvData = response
      DownloadCSV(csvData, t("Combo"))
    }
  }

  const handleExcelDownload = async () => {
    const response = await pdfDownload(EXPORT_DATA, buildExportPayload("xlsx"))
    if (response) {
      const xlsxData = response
      DownloadXLSX(xlsxData, t("Combos"))
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Combos List")}
                isAddBtn={loading ? false : usersPermissions.create}
                addBtnText={t("Add Combo")}
                onAddBtnClick={() => navigate("/menus/combos/add")}
                isExportData={loading ? false : true}
                onDownloadCSV={exportToCSV}
                onDownloadExcel={handleExcelDownload}
              />
              <CardBody>
                <ItemFilter
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  isRangeSlider={true}
                  searchBy={t("Name")}
                  priceRange={priceRange}
                  setPriceRange={setPriceRange}
                  isCountrySelected={selectedFilters.countryCode?.length > 0}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="m-auto">
          {loading ? (
            <Card>
              <TableShimmer row={7} col={3} />
            </Card>
          ) : itemsLists.length === 0 ? (
            <p className="my-3 text-center">{t("No combos found")}</p>
          ) : (
            <Card className="p-0">
              <CardBody className="p-0">
                <Table className="table mb-0 combos-list-table" hover>
                  <thead className="table-light">
                    <tr>
                      <th className="text-start combos-list-table__name-col">
                        <div className="d-flex align-items-center px-2">
                          <span className="d-inline-block py-2 ps-1">
                            {t("Combos")}
                          </span>
                        </div>
                      </th>
                      <th className="text-start">
                        <span className="d-inline-block py-2">
                          {t("Price")}
                        </span>
                      </th>
                      <th className="text-start">
                        <span className="d-inline-block py-2">
                          {t("Status")}
                        </span>
                      </th>

                      <th className="text-end combos-list-table__actions-col">
                        <span
                          className="d-inline-block py-2"
                          style={{
                            paddingInlineEnd: 60,
                            display: "block",
                          }}
                        >
                          {t("Action")}
                        </span>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsLists.map(
                      ({
                        _id,
                        name,
                        nameAr,
                        imageUrl,
                        status,
                        categoryId,
                        price,
                        countryCode,
                      }) => (
                        <tr
                          key={_id}
                          onClick={() => {
                            navigate(`/menus/combos/combo-details?id=${_id}`)
                          }}
                        >
                          <td className="text-start combos-list-table__name-col">
                            <div className="left_section ps-2 d-flex align-items-center combos-list-table__name-cell">
                              <Link to={"#"}>
                                <div className="d-flex align-items-center">
                                  <img
                                    width={47}
                                    height={44}
                                    src={imageUrl ? imageUrl : placeholderImage}
                                    style={{ objectFit: "contain" }}
                                  />
                                  <h6
                                    className="cat_title in_line_one combos-list-table__title"
                                    style={{ margin: "0 16px" }}
                                  >
                                    {language === "sa" ? nameAr : name}
                                  </h6>
                                </div>
                              </Link>
                            </div>
                          </td>
                          <td className="text-start">
                            <p
                              style={{
                                paddingTop: 13,
                                fontWeight: 500,
                                whiteSpace: "nowrap",
                              }}
                            >
                              {price}{" "}
                              {getCurrencyLabelByCountryCode(countryCode)}
                            </p>
                          </td>
                          <td className="text-start">
                            {(isTenantOwnerAdmin() ||
                              usersPermissions?.edit?.menu_full_access_update
                                ?.isEnabled) && (
                              <div style={{ marginTop: 10 }}>
                                <Switch
                                  isChecked={status}
                                  disabled={_id === selectedId && isUpdating}
                                  onClickHandler={e => {
                                    e.stopPropagation()
                                    handleStatusClick(_id, status)
                                  }}
                                />
                              </div>
                            )}
                          </td>
                          <td className="text-end combos-list-table__actions-col">
                            <div
                              className="d-flex justify-content-end align-items-center pe-2 flex-shrink-0"
                              style={{ marginTop: 10 }}
                            >
                              {(isTenantOwnerAdmin() ||
                                usersPermissions?.edit?.menu_full_access_update
                                  ?.isEnabled) && (
                                <>
                                  <i
                                    onClick={e => {
                                      e.stopPropagation()
                                      navigate(`/menus/combos/edit?id=${_id}`)
                                    }}
                                    id={`edittooltip_${_id}`}
                                    className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`edittooltip_${_id}`}
                                  >
                                    {t("Edit")}
                                  </UncontrolledTooltip>
                                </>
                              )}

                              {usersPermissions.list && (
                                <>
                                  <i
                                    onClick={e => {
                                      e.stopPropagation()
                                      navigate(
                                        `/menus/combos/combo-details?id=${_id}`
                                      )
                                    }}
                                    id={`viewtooltip_${_id}`}
                                    className="mdi mdi-eye font-size-18 text-black mx-2 cursor-pointer"
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`viewtooltip_${_id}`}
                                  >
                                    {t("View")}
                                  </UncontrolledTooltip>
                                </>
                              )}

                              {usersPermissions.delete && (
                                <>
                                  <i
                                    onClick={e => {
                                      e.stopPropagation()
                                      setItemIdToDelete(_id)
                                      setShowDeleteModal(true)
                                    }}
                                    className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                    id={`deletetooltip_${_id}`}
                                    style={{ color: "#FD5F62" }}
                                  ></i>
                                  <UncontrolledTooltip
                                    placement="top"
                                    target={`deletetooltip_${_id}`}
                                  >
                                    {t("Delete")}
                                  </UncontrolledTooltip>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                      )
                    )}
                    {/* ))} */}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          )}
        </Row>
        {!loading && (
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Paginations
                    data={itemsLists}
                    itemsPerPage={itemsPerPage}
                    onPageChange={onPageChange}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    totalCount={totalCount}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </div>
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setItemIdToDelete(null)
          setShowDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: t("Combo"),
        })}
      />
    </div>
  )
}

export default Combos
